import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
    @Output() public clickOutside = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) {}

    @HostListener('document:click', ['$event'])
    public onClick(target: any): void {
        if (!this.elementRef.nativeElement.contains(target.target)) {
            this.clickOutside.emit();
        }
    }
}
